module.exports = __webpack_public_path__ + "img/undraw_Work_chat_re_qes4.fa552c08.svg";